import React from 'react'
import { Text, View } from 'react-native'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { useTranslation } from '@flows-ui/utils/i18n'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type { TextContent } from '@flows/core/i18n/types'
import type { FlowValues } from '@flows/core/types/stepTypes'
import IconTextRow from '@ui-kit/components/IconTextRow'
import InfoNote from '@ui-kit/components/InfoNote'
import PhosphorIcon from '@ui-kit/components/PhosphorIcon'
import Separator from '@ui-kit/components/layoutComponents/Separator'
import Spacer from '@ui-kit/components/layoutComponents/Spacer'
import { COLOR } from '@ui-kit/constants'
import { body2, h2 } from '@ui-kit/core/typography'

const centeredBody = body2({ align: 'center', emphasis: 'medium' })

export interface DroneOptInProps {
  title: TextContent
  description: TextContent
  benefits?: readonly { id: string; title: TextContent }[]
  forwardedInfo?: TextContent
  flowValues?: FlowValues
}

export const DroneOptIn = ({
  title,
  description,
  benefits = [],
  forwardedInfo,
  flowValues = {},
}: DroneOptInProps) => {
  const { t } = useTranslation()
  const servicesResponses = useFlowsServicesResponses()
  const translateFunction = processStepContentElementText(t, { flowValues, servicesResponses })

  return (
    <InfoNote>
      <Spacer size="xxsmall" />
      <View className="items-center gap-y-2">
        <Text className={centeredBody}>{translateFunction(title)}</Text>
        <Text className={h2({ type: 'primary', color: 'deepForest', align: 'center' })}>
          GETSAFE
        </Text>
        <Text className={centeredBody}>{translateFunction(description)}</Text>
      </View>
      <Spacer size="medium" />
      <View className="flex flex-col gap-y-3">
        {benefits.map((benefit) => (
          <IconTextRow
            key={benefit.id}
            icon={<PhosphorIcon name="CheckCircle" size={24} weight="fill" color={COLOR.success} />}
            text={translateFunction(benefit.title)}
          />
        ))}
      </View>
      {forwardedInfo ? (
        <>
          <Separator space="medium" color="grey500" />
          <Text className={centeredBody}>{translateFunction(forwardedInfo)}</Text>
        </>
      ) : null}
      <Spacer size="xxsmall" />
    </InfoNote>
  )
}
